import React from "react";

type SelectDirProps = {
  handleSelectDir: (files: File[]) => void
};

function SelectDir(props: SelectDirProps) {
  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || [])
    props.handleSelectDir(files)
  };
  return (
    <div className="SelectDir">
      <p>ディレクトリ選択:<input
        type="file"
        onChange={handleChange}
        /* @ts-expect-error これを消すとディレクトリ属性が使えないよ */
        directory=""
        webkitdirectory="" /></p>
    </div>
  );
}

export default SelectDir;
